import React, { Component } from 'react';
import { Navbar, NavbarBrand, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';


class NavbarComponent extends Component {
    render() {
        return (
            <Navbar bg="light" expand="lg">
                <Navbar.Brand href="https://vk.com/svadbapitercom" target="_blank">Свадьба Питер</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        {!this.props.app.state.need_login &&
                            <React.Fragment>
                            {!this.props.app.state.is_user &&
                                <React.Fragment>
                                <Nav.Link><Link to="/dashboard">Альбомы</Link></Nav.Link>
                                <Nav.Link><Link to="/settings">Настройки</Link></Nav.Link>
                                <Nav.Link><Link to="/stats">Статистика</Link></Nav.Link>
                                <Nav.Link><Link to="/covers">Обложки</Link></Nav.Link>
                                <Nav.Link><Link to="/logout">Выйти из панели</Link></Nav.Link>
                                </React.Fragment>
                            }
                            {this.props.app.state.is_user &&
                                <React.Fragment>
                                <Nav.Link><Link to="/logout">Выйти из панели</Link></Nav.Link>
                                </React.Fragment>
                            }
                            </React.Fragment>
                        }
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default NavbarComponent;



// WEBPACK FOOTER //
// ./src/components/NavbarComponent.js